import React from 'react';
import { Button, ProgressBar } from 'react-native-paper';
import styled from 'styled-components/native';

import { padding } from '@src/configuration/constants';
import { persianNumber } from '@src/helpers';
import { DaysMember } from '@src/helpers';
import { H2 } from '../Typography';

import { Props } from './type';
import { Trans } from '@lingui/macro';
import { useNavigation } from '@react-navigation/native';

const Container = styled.View<{ justify?: string }>`
  margin-left: 16px;
  margin-right: 24px;
  align-items: ${({ justify }) => (justify ? justify : 'flex-start')};
  border-radius: 8px;
  border-color: ${({ theme }) => theme.colors.primary};
  padding-top: ${padding / 2}px;
  padding-bottom: ${padding / 2}px;
  padding-left: 8px;
  padding-right: 8px;
  border-width: 1.5px;
`;
const SpecialContainer = styled.View`
  margin-top: 16px;
  width: 100%;
`;
const ContainerProgress = styled.View`
  height: 100px;
  margin-top: 16px;
  margin-bottom: 8px;
  width: 100%;
  flex: 1;
`;
const RowValues = styled.View<{ align?: string }>`
  flex-direction: row;
  align-items: flex-start;
  justify-content: ${({ align }) => (align ? align : 'center')};
  width: 100%;
  margin-top: 16px;
`;
export const BoldText = styled(H2)<{ textColor?: string; margin?: number }>`
  font-weight: 700;
  margin-left: ${({ margin }) => (margin ? margin : 0)}px;
  color: ${({ theme, textColor }) =>
    textColor ? textColor : theme.colors.onAccent};
`;
export const LargeText = styled(H2)<{ textColor?: string }>`
  color: ${({ theme, textColor }) =>
    textColor ? textColor : theme.colors.onBackground};
`;
const SubmitButton = styled(Button).attrs(({ theme }) => ({
  uppercase: false,
  mode: 'contained',
  border: 1,
  borderWidth: 1,
  borderRadius: 4,
  labelStyle: {
    color: theme.colors.onPrimary,
  },
}))`
  border-radius: 8px;
  padding-left: 20%;
  padding-right: 20%;
`;
const RenewButton = styled(Button).attrs(({ theme }) => ({
  uppercase: false,
  mode: 'outlined',
  labelStyle: {
    color: theme.colors.primary,
  },
}))<{ margin?: number }>`
  margin-left: 8px;
  margin-right: ${({ margin }) => (margin ? margin : 0)}px;
  border-radius: 8px;
  border-color: ${({ theme }) => theme.colors.primary};
`;
const Subscription = ({ data, size, closeAction }: Props) => {
  const navigation = useNavigation();

  const specialProgress = data[1]?.daysRemaining
    ? data[1]?.daysRemaining /
      DaysMember(data[1]?.beginDate, data[1]?.expirationDate)
    : 0;

  const baseProgress = data[0]?.daysRemaining
    ? data[0]?.daysRemaining /
      DaysMember(data[0]?.beginDate, data[0]?.expirationDate)
    : 0;

  const goToBuyPlan = (type: boolean) => {
    navigation.navigate('PrimePlans', { isImmigration: type });
    // navigation.navigate('ImmigrationPlans');
    closeAction();
  };

  if (data[0]?.daysRemaining == 0 && data[1]?.daysRemaining == 0)
    return (
      <RenewButton margin={16} onPress={() => goToBuyPlan(true)}>
        <Trans>Buy Prime Subscription</Trans>
      </RenewButton>
    );

  return (
    <Container>
      {data[0] !== undefined && baseProgress > 0 && (
        <>
          <BoldText>اشتراک پایه</BoldText>

          <RowValues align="flex-start">
            <LargeText>مانده اعتبار:</LargeText>
            <BoldText textColor="#0A50A1" margin={4}>
              {data[0].daysRemaining !== undefined
                ? persianNumber(data[0].daysRemaining)
                : persianNumber(0)}{' '}
              <Trans>Day </Trans>
            </BoldText>
          </RowValues>

          <ContainerProgress>
            <ProgressBar
              progress={1 - baseProgress}
              color={'#EDEDED'}
              style={{
                height: 4,
                width: undefined,
                borderRadius: 2,
                backgroundColor: '#26B9B0',
              }}
            />
          </ContainerProgress>
        </>
      )}
      {data[1] !== undefined && specialProgress > 0 && (
        <SpecialContainer>
          <BoldText>اشتراک ویژه </BoldText>

          <RowValues align="flex-start">
            <LargeText>مانده اعتبار:</LargeText>
            <BoldText textColor="#0A50A1" margin={4}>
              {data[1].daysRemaining !== undefined
                ? persianNumber(data[1].daysRemaining)
                : persianNumber(0)}{' '}
              <Trans>Day </Trans>
            </BoldText>
          </RowValues>

          <ContainerProgress>
            <ProgressBar
              progress={1 - specialProgress}
              color={'#EDEDED'}
              style={{
                height: 4,
                width: undefined,
                borderRadius: 2,
                backgroundColor: '#FFD700',
              }}
            />
          </ContainerProgress>
        </SpecialContainer>
      )}
      {data &&
        data[0] !== undefined &&
        data[0].daysRemaining !== undefined &&
        data[1].daysRemaining !== undefined && (
          <RowValues align="center">
            {data[0].daysRemaining > 0 && data[1].daysRemaining == 0 && (
              <SubmitButton onPress={() => goToBuyPlan(true)}>
                ارتقا
              </SubmitButton>
            )}
            <RenewButton onPress={() => goToBuyPlan(false)}>تمدید</RenewButton>
          </RowValues>
        )}
    </Container>
  );
};

export default Subscription;
